import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { WrapperPreguntaEncuestaEstrellas } from './styles';
import iconStarEmpty from '../../../assets/img/icon/icon-star-empty.svg';
import iconStarFull from '../../../assets/img/icon/icon-star-full.svg';

const PreguntaEncuestaEstrellas = ({ cantidad, setCalificacionEstrella }) => {
  const [estrellas, setEstrellas] = useState([]);

  useEffect(() => {
    const estrellasAux = Array.from(Array(cantidad), (_, index) => {
      return { indice: index, key: `key-${index}`, estado: false };
    });
    setEstrellas(estrellasAux);
  }, []);

  const handleClick = (estrellaEstado, indice) => {
    let items = [...estrellas];
    items = items.map((item) => {
      item.estado = false;
      return item;
    });
    const item = { ...items[indice] };
    item.estado = estrellaEstado;
    items[indice] = item;
    setEstrellas(items);
    setCalificacionEstrella(indice+1);
  };

  return (
    <WrapperPreguntaEncuestaEstrellas>
      <div className="estrellasContainer">
        {estrellas.map((estrella) => {
          const width = (100 / estrellas.length).toString();
          return (
            <div
              role="button"
              id={estrella.key}
              style={{ width: `${width}%`, textAlign: 'center' }}
              onClick={() => !estrella.estado ? handleClick(true, estrella.indice) : () => {}}
              onKeyDown={() => () => {}}
              tabIndex={estrella.indice}
            >
              <img
                className={estrella.estado ? 'estrellaClickeada' : 'estrella'}
                src={estrella.estado ? iconStarFull : iconStarEmpty}
                alt="estrella"
              />
              {estrella.indice === 0 &&
                <p className="estrellaTexto">Nada satisfecho</p>}
              {(estrella.indice+1) === Math.ceil((estrellas.length+1)/2) && 
                <p className="estrellaTexto">Neutral</p>}
              {estrella.indice === estrellas.length-1 &&
                <p className="estrellaTexto">Muy satisfecho</p>}
            </div>
          );
        })}
      </div>
    </WrapperPreguntaEncuestaEstrellas>
  );
};

PreguntaEncuestaEstrellas.propTypes = {
  cantidad: PropTypes.number.isRequired,
  setCalificacionEstrella: PropTypes.func.isRequired
};

export default PreguntaEncuestaEstrellas;
